import { use } from 'react';
import {
  mockD,
  engagementScores,
  getEngagementScores,
} from './user-detail/userDetailData';
console.log(engagementScores, 'mockD');

export const detailedUserData = [
  {
    userId: 'P001',
    exportData: [],
    completedData: {
      1: [
        { completed: '2024-12-20T10:00:00', id: 11 }, // First task
        { completed: false, id: 12 }, // Day after
        { completed: false, id: 13 }, // 2-day break
        { completed: false, id: 14 },
        { completed: false, id: 15 }, // Holiday pause
        { completed: '2025-01-02T08:55:00', id: 16 }, // New Year gap
        { completed: '2025-01-02T09:10:00', id: 17 },
        { completed: '2025-01-03T08:55:00', id: 18 },
        { completed: '2025-01-03T09:12:00', id: 19 }, // Final task
      ],
      2: [
        { completed: '2024-12-28T09:10:00', id: 21 },
        { completed: '2024-12-28T09:20:00', id: 22 },
        { completed: '2024-12-29T08:55:00', id: 23 },
        { completed: '2024-12-30T10:00:00', id: 24 },
        { completed: '2025-01-01T11:00:00', id: 25 }, // New Year Day grind
        { completed: '2025-01-01T11:10:00', id: 26 },
        { completed: '2025-01-03T09:30:00', id: 27 },
        { completed: '2025-01-03T09:40:00', id: 28 },
        { completed: '2025-01-04T10:00:00', id: 29 },
        { completed: false, id: 210 }, // intentionally skipped
        { completed: '2025-01-05T14:00:00', id: 211 },
        { completed: '2025-01-05T14:15:00', id: 212 },
        { completed: '2025-01-05T14:38:00', id: 213 }, // Final for module 2
      ],
      3: [
        { completed: '2025-01-02T09:00:00', id: 31 },
        { completed: '2025-01-02T09:10:00', id: 32 },
        { completed: '2025-01-03T10:30:00', id: 33 },
        { completed: '2025-01-04T08:50:00', id: 34 },
        { completed: '2025-01-04T09:00:00', id: 35 },
        { completed: '2025-01-06T10:00:00', id: 36 },
        { completed: false, id: 37 }, // skipped
        { completed: false, id: 38 }, // skipped
        { completed: '2025-01-07T10:30:00', id: 39 },
        { completed: '2025-01-07T11:27:00', id: 310 },
      ],
      4: [
        { completed: '2025-01-05T09:00:00', id: 41 },
        { completed: '2025-01-05T09:08:00', id: 42 },
        { completed: '2025-01-05T09:17:00', id: 43 },
        { completed: '2025-01-06T08:50:00', id: 44 },
        { completed: '2025-01-06T08:58:00', id: 45 },
        { completed: '2025-01-06T09:10:00', id: 46 },
        { completed: '2025-01-07T11:30:00', id: 47 },
        { completed: '2025-01-07T11:45:00', id: 48 },
        { completed: '2025-01-07T11:53:00', id: 49 },
        { completed: '2025-01-08T10:00:00', id: 410 },
        { completed: '2025-01-08T10:10:00', id: 411 },
        { completed: false, id: 412 },
        { completed: false, id: 413 },
        { completed: '2025-01-08T10:20:00', id: 414 },
        { completed: '2025-01-09T16:05:00', id: 415 },
      ],
      5: [
        { completed: '2025-01-08T09:05:00', id: 51 },
        { completed: '2025-01-08T09:12:00', id: 52 },
        { completed: '2025-01-08T09:22:00', id: 53 },
        { completed: '2025-01-09T10:00:00', id: 54 },
        { completed: '2025-01-09T10:08:00', id: 55 },
        { completed: '2025-01-10T11:20:00', id: 56 },
        { completed: '2025-01-10T11:35:00', id: 57 },
        { completed: false, id: 58 },
        { completed: '2025-01-10T11:50:00', id: 59 },
        { completed: '2025-01-11T10:45:00', id: 510 },
      ],
      6: [
        { completed: '2025-01-12T09:00:00', id: 61 },
        { completed: '2025-01-12T09:08:00', id: 62 },
        { completed: '2025-01-13T10:00:00', id: 63 },
        { completed: '2025-01-13T10:10:00', id: 64 },
        { completed: '2025-01-13T10:20:00', id: 65 },
        { completed: '2025-01-13T10:35:00', id: 66 },
        { completed: '2025-01-13T10:45:00', id: 67 },
        { completed: '2025-01-13T10:55:00', id: 68 },
        { completed: false, id: 69 },
        { completed: false, id: 610 },
        { completed: '2025-01-14T17:50:00', id: 611 },
        { completed: '2025-01-14T18:22:00', id: 612 },
      ],
    },
  },
  {
    userId: 'P002',
    exportData: [],
    completedData: {
      1: [
        { completed: '2025-01-10T08:00:00', id: 11 },
        { completed: '2025-01-10T08:08:00', id: 12 },
        { completed: '2025-01-10T08:16:00', id: 13 },
        { completed: '2025-01-10T08:23:00', id: 14 },
        { completed: '2025-01-10T08:31:00', id: 15 },
        { completed: '2025-01-12T09:00:00', id: 16 },
        { completed: '2025-01-12T09:08:00', id: 17 },
        { completed: '2025-01-14T10:15:00', id: 18 },
        { completed: '2025-01-16T08:15:00', id: 19 },
      ],

      2: [
        { completed: '2025-01-17T10:00:00', id: 21 },
        { completed: '2025-01-17T10:07:00', id: 22 },
        { completed: '2025-01-17T10:16:00', id: 23 },
        { completed: '2025-01-17T10:25:00', id: 24 },
        { completed: '2025-01-18T09:00:00', id: 25 },
        { completed: '2025-01-18T09:09:00', id: 26 },
        { completed: '2025-01-18T09:17:00', id: 27 },
        { completed: '2025-01-18T09:26:00', id: 28 },
        { completed: '2025-01-18T09:35:00', id: 29 },
        { completed: '2025-01-18T10:00:00', id: 210 },
        { completed: '2025-01-18T10:08:00', id: 211 },
        { completed: '2025-01-18T10:15:00', id: 212 },
        { completed: '2025-01-18T13:47:00', id: 213 },
      ],

      3: [
        { completed: '2025-01-19T08:00:00', id: 31 },
        { completed: '2025-01-19T08:07:00', id: 32 },
        { completed: false, id: 33 },
        { completed: false, id: 34 },
        { completed: '2025-01-19T08:20:00', id: 35 },
        { completed: '2025-01-19T08:27:00', id: 36 },
        { completed: '2025-01-19T08:35:00', id: 37 },
        { completed: '2025-01-19T08:42:00', id: 38 },
        { completed: '2025-01-19T08:50:00', id: 39 },
        { completed: '2025-01-20T10:03:00', id: 310 },
      ],
    },
  },
  {
    userId: 'P003',
    exportData: [],
    completedData: {
      1: [
        { completed: '2025-01-28T08:00:00', id: 11 },
        { completed: '2025-01-28T08:08:00', id: 12 },
        { completed: '2025-01-28T08:17:00', id: 13 },
        { completed: '2025-01-28T08:26:00', id: 14 },
        { completed: '2025-01-28T08:33:00', id: 15 },
        { completed: '2025-01-30T09:05:00', id: 16 },
        { completed: '2025-01-30T09:15:00', id: 17 },
        { completed: '2025-01-31T10:30:00', id: 18 },
        { completed: '2025-02-02T09:22:00', id: 19 },
      ],

      2: [
        { completed: '2025-02-03T10:00:00', id: 21 },
        { completed: false, id: 22 },
        { completed: false, id: 23 },
        { completed: false, id: 24 },
        { completed: false, id: 25 },
        { completed: '2025-02-03T10:10:00', id: 26 },
        { completed: '2025-02-03T10:18:00', id: 27 },
        { completed: '2025-02-03T10:27:00', id: 28 },
        { completed: false, id: 29 },
        { completed: false, id: 210 },
        { completed: '2025-02-04T11:00:00', id: 211 },
        { completed: '2025-02-04T11:10:00', id: 212 },
        { completed: '2025-02-05T14:40:00', id: 213 },
      ],

      3: [
        { completed: '2025-02-06T08:00:00', id: 31 },
        { completed: '2025-02-06T08:08:00', id: 32 },
        { completed: false, id: 33 },
        { completed: false, id: 34 },
        { completed: '2025-02-06T08:18:00', id: 35 },
        { completed: '2025-02-06T08:27:00', id: 36 },
        { completed: '2025-02-06T08:35:00', id: 37 },
        { completed: '2025-02-06T08:43:00', id: 38 },
        { completed: '2025-02-06T08:52:00', id: 39 },
        { completed: '2025-02-08T11:10:00', id: 310 },
      ],

      4: [
        { completed: '2025-02-09T08:00:00', id: 41 },
        { completed: '2025-02-09T08:08:00', id: 42 },
        { completed: '2025-02-09T08:17:00', id: 43 },
        { completed: '2025-02-09T08:26:00', id: 44 },
        { completed: '2025-02-09T08:34:00', id: 45 },
        { completed: '2025-02-09T08:42:00', id: 46 },
        { completed: '2025-02-09T08:50:00', id: 47 },
        { completed: '2025-02-09T08:59:00', id: 48 },
        { completed: '2025-02-09T09:07:00', id: 49 },
        { completed: false, id: 410 },
        { completed: false, id: 411 },
        { completed: false, id: 412 },
        { completed: false, id: 413 },
        { completed: '2025-02-09T10:50:00', id: 414 },
        { completed: '2025-02-09T11:10:00', id: 415 },
      ],
    },
  },
  {
    userId: 'P004',
    exportData: [],
    completedData: {
      1: [
        { completed: '2025-02-24T09:05:00', id: 11 },
        { completed: '2025-02-24T09:14:00', id: 12 },
        { completed: '2025-02-24T09:23:00', id: 13 },
        { completed: '2025-02-25T10:30:00', id: 14 },
        { completed: '2025-02-25T10:39:00', id: 15 },
        { completed: '2025-02-26T08:50:00', id: 16 },
        { completed: '2025-02-26T09:00:00', id: 17 },
        { completed: '2025-03-01T14:12:00', id: 18 },
        { completed: '2025-03-02T15:28:00', id: 19 },
      ],
    },
  },
  {
    userId: 'P005',
    exportData: [],
    completedData: {
      1: [
        { completed: '2025-02-25T09:00:00', id: 11 },
        { completed: false, id: 12 },
        { completed: false, id: 13 },
        { completed: false, id: 14 },
        { completed: false, id: 15 },
        { completed: '2025-02-26T10:18:00', id: 16 },
        { completed: '2025-02-26T10:27:00', id: 17 },
        { completed: '2025-02-27T15:42:00', id: 18 },
        { completed: '2025-03-03T15:20:00', id: 19 },
      ],
      2: [
        { completed: '2025-03-04T09:15:00', id: 21 },
        { completed: '2025-03-04T09:25:00', id: 22 },
        { completed: '2025-03-04T09:35:00', id: 23 },
        { completed: '2025-03-04T09:50:00', id: 24 },
        { completed: '2025-03-04T10:00:00', id: 25 },
        { completed: '2025-03-05T10:10:00', id: 26 },
        { completed: '2025-03-05T10:20:00', id: 27 },
        { completed: '2025-03-05T10:30:00', id: 28 },
        { completed: '2025-03-05T10:45:00', id: 29 },
        { completed: false, id: 210 },
        { completed: '2025-03-06T08:55:00', id: 211 },
        { completed: '2025-03-06T09:03:00', id: 212 },
        { completed: '2025-03-07T11:22:00', id: 213 },
      ],
      3: [
        { completed: '2025-03-08T08:30:00', id: 31 },
        { completed: '2025-03-08T08:40:00', id: 32 },
        { completed: '2025-03-08T08:55:00', id: 33 },
        { completed: '2025-03-08T09:10:00', id: 34 },
        { completed: '2025-03-09T10:15:00', id: 35 },
        { completed: '2025-03-09T10:30:00', id: 36 },
        { completed: '2025-03-09T10:45:00', id: 37 },
        { completed: '2025-03-09T11:00:00', id: 38 },
        { completed: '2025-03-09T11:20:00', id: 39 },
        { completed: '2025-03-10T09:40:00', id: 310 },
      ],
      4: [
        { completed: '2025-03-11T08:30:00', id: 41 },
        { completed: '2025-03-11T08:40:00', id: 42 },
        { completed: '2025-03-11T08:55:00', id: 43 },
        { completed: '2025-03-11T09:05:00', id: 44 },
        { completed: '2025-03-11T09:20:00', id: 45 },
        { completed: '2025-03-11T09:30:00', id: 46 },
        { completed: false, id: 47 },
        { completed: false, id: 48 },
        { completed: false, id: 49 },
        { completed: false, id: 410 },
        { completed: false, id: 411 },
        { completed: false, id: 412 },
        { completed: false, id: 413 },
        { completed: '2025-03-12T14:50:00', id: 414 },
        { completed: '2025-03-13T10:25:00', id: 415 },
      ],
    },
  },
];

const P001engagementScores = getEngagementScores(
  detailedUserData[0].completedData
);

const P002engagementScores = getEngagementScores(
  detailedUserData[1].completedData
);

const P003engagementScores = getEngagementScores(
  detailedUserData[2].completedData
);

const P004engagementScores = getEngagementScores(
  detailedUserData[3].completedData
);

const P005engagementScores = getEngagementScores(
  detailedUserData[4].completedData
);

console.log(P001engagementScores, 'P001engagementScores');

export const data = {
  org: '101',
  groups: [],
  facilitators: [
    {
      id: 'F001',
      name: 'Maria Thompson',
      email: 'maria.thompson@test.org',
      phone: '555-0101',
    },
    {
      id: 'F002',
      name: 'James Carter',
      email: 'james.carter@test.org',
      phone: '555-0102',
    },
    {
      id: 'F003',
      name: 'Alicia Nguyen',
      email: 'alicia.nguyen@test.org',
      phone: '555-0103',
    },
    {
      id: 'F004',
      name: 'David Ramirez',
      email: 'david.ramirez@test.org',
      phone: '555-0104',
    },
    {
      id: '101F6',
      name: 'Brianna Lewis',
      email: 'brianna.lewis@test.org',
      phone: '555-0105',
    },
    {
      id: '101F7',
      name: 'Kevin Patel',
      email: 'kevin.patel@test.org',
      phone: '555-0106',
    },
    {
      id: '101F8',
      name: 'unassigned',
      email: '',
      phone: '',
    },
    {
      id: '101F9',
      name: 'unassigned',
      email: '',
      phone: '',
    },
    {
      id: '101F10',
      name: 'unassigned',
      email: '',
      phone: '',
    },
  ],
  members: [
    {
      id: 'P001',
      name: 'Alice Smith',
      email: 'alice.smith@test.org',
      phone: '555-1001',
      progress: [
        {
          completed: '2025-01-03T09:12:00',
          engagementScore: P001engagementScores[0].engagementScore,
        },
        {
          completed: '2025-01-05T14:38:00',
          engagementScore: P001engagementScores[1].engagementScore,
        },
        {
          completed: '2025-01-07T11:27:00',
          engagementScore: P001engagementScores[2].engagementScore,
        },
        {
          completed: '2025-01-09T16:05:00',
          engagementScore: P001engagementScores[3].engagementScore,
        },
        {
          completed: '2025-01-11T10:45:00',
          engagementScore: P001engagementScores[4].engagementScore,
        },
        {
          completed: '2025-01-14T18:22:00',
          engagementScore: P001engagementScores[5].engagementScore,
        },
      ],
    },
    {
      id: 'P002',
      name: 'Bob Johnson',
      email: 'bob.johnson@test.org',
      phone: '555-1002',
      progress: [
        {
          completed: '2025-01-16T08:15:00',
          engagementScore: P002engagementScores[0].engagementScore,
        },
        {
          completed: '2025-01-18T13:47:00',
          engagementScore: P002engagementScores[1].engagementScore,
        },
        {
          completed: '2025-01-20T10:03:00',
          engagementScore: P002engagementScores[2].engagementScore,
        },
        { completed: undefined },
        { completed: undefined },
        { completed: undefined },
      ],
    },
    {
      id: 'P003',
      name: 'Charlie Williams',
      email: 'charlie.williams@test.org',
      phone: '555-1003',
      progress: [
        {
          completed: '2025-02-02T09:22:00',
          engagementScore: P003engagementScores[0].engagementScore,
        },
        {
          completed: '2025-02-05T14:40:00',
          engagementScore: P003engagementScores[1].engagementScore,
        },
        {
          completed: '2025-02-08T11:10:00',
          engagementScore: P003engagementScores[2].engagementScore,
        },
        {
          completed: '2025-02-09T11:10:00',
          engagementScore: P003engagementScores[3].engagementScore,
        },
        {},
        {},
      ],
    },
    {
      id: 'P004',
      name: 'David Brown',
      email: 'david.brown@test.org',
      phone: '555-1004',
      progress: [
        {
          completed: '2025-03-02T15:28:00',
          engagementScore: P004engagementScores[0].engagementScore,
        },
        {},
        {},
        {},
        {},
        {},
      ],
    },
    {
      id: 'P005',
      name: 'Emma Jones',
      email: 'emma.jones@test.org',
      phone: '555-1005',
      progress: [
        {
          completed: '2025-03-03T15:20:00',
          engagementScore: P005engagementScores[0].engagementScore,
        },
        {
          completed: '2025-03-05T10:05:00',
          engagementScore: P005engagementScores[1].engagementScore,
        },
        {
          completed: '2025-03-07T18:40:00',
          engagementScore: P005engagementScores[2].engagementScore,
        },
        {
          completed: '2025-03-10T09:15:00',
          engagementScore: P005engagementScores[3].engagementScore,
        },
        {},
        {},
      ],
    },
    // {
    //   id: 'P006',
    //   name: 'Frank Miller',
    //   email: 'frank.miller@test.org',
    //   phone: '555-1006',
    //   progress: [
    //     { completed: '2025-01-08', engagementScore: 82 },
    //     { completed: '2025-01-15', engagementScore: 85 },
    //     { completed: '2025-01-22', engagementScore: 80 },
    //     { completed: '2025-01-29', engagementScore: 88 },
    //     {},
    //     {},
    //   ],
    // },
    // {
    //   id: 'P007',
    //   name: 'Grace Davis',
    //   email: 'grace.davis@test.org',
    //   phone: '555-1007',
    //   progress: [
    //     { completed: '2025-01-09', engagementScore: 66 },
    //     {},
    //     {},
    //     {},
    //     {},
    //     {},
    //   ],
    // },
    // {
    //   id: 'P008',
    //   name: 'Henry Wilson',
    //   email: 'henry.wilson@test.org',
    //   phone: '555-1008',
    //   progress: [
    //     { completed: '2025-01-11', engagementScore: 95 },
    //     { completed: '2025-01-18', engagementScore: 90 },
    //     { completed: '2025-01-17', engagementScore: 40 },
    //     {},
    //     {},
    //     {},
    //   ],
    // },
    // {
    //   id: 'P009',
    //   name: 'Isabella Taylor',
    //   email: 'isabella.taylor@test.org',
    //   phone: '555-1009',
    //   progress: [{}, {}, {}, {}, {}, {}],
    // },
    // {
    //   id: 'P010',
    //   name: 'Jack Anderson',
    //   email: 'jack.anderson@test.org',
    //   phone: '555-1010',
    //   progress: [
    //     { completed: '2025-01-10', engagementScore: 83 },
    //     { completed: '2025-01-17', engagementScore: 81 },
    //     { completed: '2025-01-24', engagementScore: 79 },
    //     { completed: '2025-01-31', engagementScore: 85 },
    //     { completed: '2025-02-07', engagementScore: 80 },
    //     {},
    //   ],
    // },
  ],
};
